import { createRoot } from 'react-dom/client'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import { StylesProvider } from '@material-ui/core/styles'
import { MantineProvider } from '@mantine/core'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import 'react-tabs/style/react-tabs.css'
import 'rc-tooltip/assets/bootstrap_white.css'

import { authUser } from 'common/actions/auth'
import { loadSelectedProject } from 'common/actions/projects'
import { initLocalize } from 'common/actions/localize'
import configureStore from 'utils/configureStore'
import makeRootSaga from 'common/sagas'
import Root from 'common/components/Root'
import { clearLegacyAuthStoreData } from 'utils/authStore'
import { listenForEndedSession } from 'utils/sessionListener'

import { Amplify } from 'aws-amplify'
import { AWS_COGNITO_USER_POOL_ID, AWS_COGNITO_WEB_CLIENT_ID } from './config'

// Amplify v6 config shape. The region is inferred from the user pool id.
// The v4-only options (mandatorySignIn, authenticationFlowType) are gone;
// USER_SRP_AUTH is the default flow and can be set per signIn call if needed.
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: AWS_COGNITO_USER_POOL_ID,
      userPoolClientId: AWS_COGNITO_WEB_CLIENT_ID
    }
  }
})

const store = configureStore({}, browserHistory)
const history = syncHistoryWithStore(browserHistory, store)
store.runSaga(makeRootSaga())

clearLegacyAuthStoreData()

listenForEndedSession(store.dispatch)

store.dispatch(authUser())
store.dispatch(loadSelectedProject())
store.dispatch(initLocalize())

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)
root.render(
  <MantineProvider>
    <StylesProvider injectFirst>
      <Root
        store={store}
        history={history}
      />
    </StylesProvider>
  </MantineProvider>
)

export { store }
